<script>
    export let size = "16px";

</script>
<div style="min-height:{size}"></div>